const Label = function () {
  return null;
};
export default Label;
